import { useCallback } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useSelectedTrade } from '~/context/common/TradeContext';
import { PricingResponse } from '~/services/common/contracts';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { ChangeLog } from './useGetPricing';

type OwnProps = {
  changeLog: ChangeLog;
};

export default function useSendPriceUpdateEvent({ changeLog }: OwnProps) {
  const trackEvent = useTrackEvent();
  const selectedTrade = useSelectedTrade();
  const { maxTradeTaxSavings } = selectedTrade ?? {};

  return useCallback(
    (data: PricingResponse) => {
      if (changeLog.initialCall) return;

      const formattedData = Object.entries(data.vehiclePaymentTermsMapping).map(
        ([key, value]) => ({
          vehicleId: key,
          tileInfo: {
            apr: value.apr,
            estimatedTaxesAndFees: value.estimatedTaxesAndFees,
            downPayment: value.downPayment,
            monthlyPayment: value.monthlyPayment,
            term: value.termInMonths
          }
        })
      );

      trackEvent('mega-srp-pricing-update', {
        requestTrigger: changeLog.softpullRefresh
          ? 'softpullRefresh'
          : 'tradeToggle',
        tileInfo: formattedData,
        financeInfo: data.financeInfo,
        tradeInfo: {
          ...data.tradeInfo,
          maxTradeTaxSavings: maxTradeTaxSavings
            ? formatAndDropDecimal(maxTradeTaxSavings)
            : undefined
        }
      });
    },
    [changeLog, maxTradeTaxSavings, trackEvent]
  );
}
